import React, { useRef, useCallback, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
// Import Swiper styles
import { Grid } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { motion, useScroll } from "framer-motion";
import { MediaQueries } from '../utils';
// import required modules

export default function ImageCarousel({ images,current_image, setcurrent_image }) {

  const { isMobile } = MediaQueries()

  const sliderRef = useRef(null);
  const [scrollProgress, setScroll] = useState(0.4)
  const [slidesPerView, setslidesperView] = useState()

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <Swiper
      ref={sliderRef}
      loop
      breakpoints={{
        200: {
          slidesPerView: 3.5,
        },
        450: {
          slidesPerView: 3.5,
        },
        760: {
          slidesPerView: 5,
        },
        1000: {
          slidesPerView: 4.5,
        },
        1200: {
          slidesPerView: 4.5,
        },
        1400: {
          slidesPerView: 4.5,
        },
        1600: {
          slidesPerView: 4.5,
        }
      }}
      spaceBetween={isMobile ? 15 : 10}
      onBreakpoint={(swiper, breakpoint) => {
        setslidesperView(isMobile ? 8 : breakpoint.slidesPerView)
      }}
      className="product_Detail_carousel"
    >
      {
        images.map((image, index) => {
          return (
            <SwiperSlide style={{borderColor:current_image == index && '#3B82F6'}}>
              <div className='position-relative' >
                <img src={image} alt='' onClick={(e) => {
                  setcurrent_image(index)
                }} />
              </div>
            </SwiperSlide>
          )
        })
      }
      {
        (!isMobile && images.length > 4) &&
        <div className='arrows' style={{zIndex:'unset'}}>
          <div className='left_indicator previous' onClick={handlePrev} style={{zIndex:9}}>
            <IoChevronBack size={25} />
          </div>
          <div className='right_indicator next' onClick={handleNext} style={{zIndex:9}}>
            <IoChevronForward size={25} />
          </div>
        </div>
      }

    </Swiper>
  );
}
